<template>
	<div>
		<slot name="text"></slot>
		<div v-if="componentParent !== 'REASSIGN_EVENTS' && componentParent !== 'ON_DEMAND'" id="card-resource-list">
			<div class="vx-row flex justify-center" v-if="enableSearch">
				<div class="vx-col md:w-1/2">
					<label class="vs-input--label">{{ $t("SearchBy") }}</label>
					<v-select
						v-model="searchFieldSelected"
						:clearable="false"
						:options="searchOptions"
						v-validate="'required'"
						name="country"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
				</div>
				<div class="vx-col md:w-1/2 p-0">
					<!-- Append Two Buttons -->
					<label class="vs-input--label">{{ "" }}</label>
					<vx-input-group>
						<vs-input
							icon-no-border
							:placeholder="$t('Search')"
							v-model="searchQuery"
							@keyup.enter="searchResource"
							class="w-full"
						/>

						<template slot="append">
							<div class="append-text btn-addon">
								<vs-button
									:title="$t('Search')"
									color="primary"
									type="border"
									icon-pack="feather"
									icon="icon-search"
									@click="searchResource"
								></vs-button>
								<vs-button
									:title="$t('Schedule.Refresh')"
									color="primary"
									type="border"
									icon-pack="feather"
									icon="icon-refresh-cw"
									@click="refresh"
								></vs-button>
							</div>
						</template>
					</vx-input-group>
					<!-- /Append Two Buttons -->
				</div>
			</div>
			<slot name="text"></slot>
			<!-- AgGrid Table -->
			<ag-grid-vue
				id="card-resource-list2"
				ref="agGridTable"
				class="ag-theme-material w-100 my-4 ag-grid-table"
				colResizeDefault="shift"
				:components="components"
				:gridOptions="gridOptions"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="resources"
				:rowSelection="customConfig.rowSelection"
				:animateRows="true"
				:floatingFilter="false"
				:suppressPaginationPanel="true"
				:enableRtl="$vs.rtl"
				:getRowStyle="getRowStyle"
				:overlayNoRowsTemplate="overlayNoRowsTemplate"
				@selection-changed="onSelectionChanged"
				@rowSelected="rowSelected"
			>
			</ag-grid-vue>
			<vs-pagination :total="totalPages" :max="5" v-model="currentPage" goto />
		</div>
		<div v-if="componentParent === 'REASSIGN_EVENTS'" id="card-resource-list1">
			<vs-navbar :type="'flat'" v-model="activeItem" class="nabarx">
				<vs-navbar-item index="1">
					<!-- SEARCH -->
					<div class="search-page__search-bar flex items-center mt-3 mb-3">
						<vs-input
							icon-no-border
							:placeholder="$t('Search')"
							v-model="searchQuery"
							@keyup.enter="searchResource"
							class="w-full"
							icon="icon-search"
							icon-pack="feather"
						/>
					</div>
				</vs-navbar-item>
				<vs-navbar-item index="2">
					<vs-button
						:title="$t('Search')"
						class="ml-2"
						color="primary"
						type="border"
						icon-pack="feather"
						icon="icon-search"
						@click="searchResource"
					></vs-button>
				</vs-navbar-item>
				<vs-navbar-item index="3">
					<vs-button
						:title="$t('Schedule.Refresh')"
						class="ml-2"
						color="primary"
						type="border"
						icon-pack="feather"
						icon="icon-refresh-cw"
						@click="refresh"
					></vs-button>
				</vs-navbar-item>
			</vs-navbar>
			<vs-pagination v-if="paginationEnable" :total="totalPages" :max="7" v-model="currentPage" class="mt-5" />
			<vue-perfect-scrollbar class="scroll-area" :settings="settings">
				<!-- RESOURCE LIST -->
				<ul class="bordered-items">
					<li class="cursor-pointer" v-for="resource in resourcesDataFilter" :key="resource.uid">
						<resource-list-item
							v-if="componentParent === 'REASSIGN_EVENTS'"
							:resource="resource"
							:componentParent="componentParent"
							:isActiveChatUser="isActiveChatUser"
							:multiple="multiple"
						></resource-list-item>
					</li>
				</ul>
			</vue-perfect-scrollbar>
		</div>
		<div v-else-if="componentParent === 'ON_DEMAND'" id="card-resource-list2">
			<vs-input
				v-if="enableSimpleSearchQuery"
				icon-no-border
				:placeholder="$t('Search')"
				v-model="simpleSearchQuery"
				class="w-full mb-4"
			/>
			<vs-divider class="d-theme-border-grey-light mt-1" />
			<vue-perfect-scrollbar :style="scrollArea" :settings="settings">
				<!-- RESOURCE LIST -->
				<ul v-if="resourcesDataFilter.length > 0" class="bordered-items">
					<li class="cursor-pointer" v-for="resource in resourcesDataFilter" :key="resource.uid">
						<resource-list-item
							v-if="componentParent === 'ON_DEMAND'"
							:resource="resource"
							:componentParent="componentParent"
							:isActiveChatUser="isActiveChatUser"
							:multiple="multiple"
						></resource-list-item>
					</li>
				</ul>
				<p v-else>
					<vs-alert class="mb-2" color="primary" :title="$t('Resource.Resources')">
						{{ $t("general.NoResultsFoundFor") + " "
						}}<em class="g-label--normal">"{{ simpleSearchQuery }}"</em>
					</vs-alert>
				</p>
			</vue-perfect-scrollbar>
		</div>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NotPermission from "@/views/pages/NotPermission.vue";
import moduleResource from "@/store/resource/moduleResource.js";
import ResourceListItem from "./ResourceListItem.vue";
import User from "@/models/User.js";
import ResourceListItemSideBar from "./ResourceListItemSideBar.vue";
import {AgGridVue} from "ag-grid-vue";
import vSelect from "vue-select";
import CellRendererStatus from "../resource/user-list/cell-renderer/CellRendererStatus";
import CellRendererVerified from "../resource/user-list/cell-renderer/CellRendererVerified";
import CellRendererActions from "../resource/user-list/cell-renderer/CellRendererActions";

export default {
	components: {
		VuePerfectScrollbar,
		NotPermission,
		ResourceListItem,
		ResourceListItemSideBar,
		AgGridVue,
		vSelect,
		// Cell Renderer
		CellRendererStatus,
		CellRendererVerified,
		CellRendererActions,
	},
	props: {
		title: {type: String, default: ""},
		componentParent: {type: String, default: "RESOURCE_CALENDAR"},
		isActiveChatUser: {type: Boolean, default: true},
		paginationEnable: {type: Boolean, default: true},
		resource_ids: {type: Array, default: () => []},
		removeColumns: {
			type: Boolean,
			default: () => false,
			required: false,
		},
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "single",
					activeCheckbox: true,
					columns: [],
					actionDropdown: true,
					btnAssigResources: false,
					popupMode: false,
					importMode: false,
					link: true,
				};
			},
		},
		multiple: false,
		enableSearch: {type: Boolean, default: true},
		enableSimpleSearchQuery: {type: Boolean, default: false},
		scrollArea: {
			type: Object,
			default: () => {
				return {
					margin: " auto",
					width: " 100%",
					"min-height": "  475px",
					"max-height": "  475px",
				};
			},
		},
	},
	data() {
		return {
			activeItem: "",
			activeAlert: true,
			searchQuery: null,
			userSession: new User(),
			currentSelectResource: null,
			active: true,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.7,
			},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 100,
			checkedAll: false,
			searchField: "Name",
			// Style loading
			backgroundLoading: "#FFFFFF",
			colorLoading: "primary",
			// AgGrid
			gridApi: null,
			gridOptions: {},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			// Cell Renderer Components
			components: {
				CellRendererStatus,
				CellRendererVerified,
				CellRendererActions,
			},
			columnsConfigWidth: {
				email: this.removeColumns ? 300 : 225,
				lastname: this.removeColumns ? 250 : 200,
				identification: this.removeColumns ? 250 : 200,
				name: this.removeColumns ? 250 : 200,
				username: this.removeColumns ? 250 : 200,
			},
			getRowStyle: null,
			simpleSearchQuery: null,
			searchFieldSelected: {value: "Name", label: this.$t("Name")},
		};
	},
	watch: {
		currentPage(val) {
			this.getResources();
			this.currentSelectResource = null;
		},
		searchFieldSelected(val) {
			this.searchField = val.value;
		},
	},
	computed: {
		// Colunms to render
		columnDefs() {
			let filterHead = false;
			// Columns
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 125,
					filter: filterHead,
					pinned: "left",
					lockPinned: true,
				},
				{
					headerName: this.$t("Username"),
					field: "username",
					filter: filterHead,
					width: this.columnsConfigWidth.username,
				},
				{
					headerName: this.$t("Name"),
					field: "name",
					filter: filterHead,
					width: this.columnsConfigWidth.name,
				},
				{
					headerName: this.$t("Lastname"),
					field: "lastname",
					filter: filterHead,
					width: this.columnsConfigWidth.lastname,
				},
				{
					headerName: this.$t("Email"),
					field: "email",
					filter: filterHead,
					width: this.columnsConfigWidth.email,
				},
				{
					headerName: this.$t("Identification"),
					field: "identification",
					filter: filterHead,
					width: this.columnsConfigWidth.identification,
				},
				{
					headerName: this.$t("Role"),
					field: "alias",
					filter: filterHead,
					width: 150,
				},
				{
					headerName: this.$t("Status"),
					field: "status",
					filter: filterHead,
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
				{
					headerName: this.$t("Type"),
					field: "typology_name",
					filter: filterHead,
					width: 150,
				},
			];

			// Filter table columns to show if showColumns is provided
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		resources() {
			return this.$store.state.moduleResource.resources;
		},
		resourcesDataFilter() {
			const data = this.resources;
			if (!this.simpleSearchQuery || this.simpleSearchQuery.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return (
					r.name.toLowerCase().includes(this.simpleSearchQuery.toLowerCase()) ||
					r.email.toLowerCase().includes(this.simpleSearchQuery.toLowerCase())
				);
			});
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		resourceFullname() {
			return this.currentSelectResource !== null ? this.currentSelectResource.name : "";
		},
		currentResourceId() {
			const currentResource = this.$store.getters["moduleSchedule/getCurrentResource"];
			if (currentResource.hasOwnProperty("id")) {
				return currentResource.id;
			} else {
				return 0;
			}
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		searchOptions() {
			return [
				{value: "Name", label: this.$t("Name")},
				{value: "Identification", label: this.$t("Identification")},
				{value: "Email", label: this.$t("Email")},
				{value: "Address", label: this.$t("Address")},
				{value: "City", label: this.$t("City")},
			];
		},
	},
	methods: {
		onSelectionChanged(event) {
			let rowCount = event.api.getSelectedNodes();
		},
		rowSelected(event) {
			this.$store.commit("moduleSchedule/SET_REASSIGNED_DATE", null);
			this.$store.commit("moduleSchedule/SELECTED_RESOURCE", event.data);
			this.$store.commit("moduleResource/SET_SELECTED_RESOURCE", event.data);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		handHorder() {
			this.$store.commit("moduleResource/ORDER_DATA");
		},
		getResources(dataPage = {page: this.currentPage, quantity: this.quantityElementPage}) {
			this.$store.commit("moduleResource/CLEAR_RESOURCES");
			this.$vs.loading();
			const r = this.$store.getters["moduleRoles/getExcuteSupervisorRolesId"];
			if (this.componentParent === "ON_DEMAND") {
				dataPage["ids"] = this.resource_ids;
			}
			this.$store
				.dispatch("moduleResource/fetchResourceFilter", {...dataPage, role_id: r})
				.then((res) => {
					Object.assign(this.pagination, res.data.pagination);
					this.searchQuery = "";
					this.$vs.loading.close();
				})
				.catch((err) => {
					this.$vs.loading.close();
					throw new Error(err);
				});
		},
		searchResource() {
			const dataPage = {
				name: this.searchField === "Name" ? this.searchQuery : "",
				lastname: this.searchField === "Lastname" ? this.searchQuery : "",
				username: this.searchField === "Username" ? this.searchQuery : "",
				identification: this.searchField === "Identification" ? this.searchQuery : "",
				email: this.searchField === "Email" ? this.searchQuery : "",
				imei: this.searchField === "Imei" ? this.searchQuery : "",
				order_by: "name",
				sort: "ASC",
			};
			this.getResources(dataPage);
		},
		refresh() {
			const dataPage = {
				page: this.currentPage,
				quantity: this.quantityElementPage,
			};
			this.getResources(dataPage);
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		this.getRowStyle = (params) => {
			const resourceId = params.data.id;
			if (resourceId === this.currentResourceId)
				return {
					color: "white",
					fontWeight: "bold",
					background:
						"linear-gradient(118deg,rgba(var(--vs-primary),1),rgba(var(--vs-primary),.7))!important",
					boxShadow: "0 15px 30px 0 rgba(0,0,0,.11),0 5px 15px 0 rgba(0,0,0,.08)!important",
				};
		};
	},
	mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$store.state.moduleResource.resources.length <= 0) {
			this.getResources();
		}
	},
	beforeDestroy() {
		this.$store.commit("moduleResource/CLEAR_RESOURCES");
	},
	beforeCreate() {
		this.$store.commit("moduleResource/CLEAR_RESOURCES");
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 475px;
	max-height: 475px;
}

.scroll-area--ondemand {
	margin: auto;
	width: 100%;
	min-height: 200px;
	max-height: 200px;
}

.scroll-area--sidebard-height {
	margin: auto;
	width: 100%;
	min-height: 100%;
	max-height: 100%;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
	background: chocolate;
}

.slide-fade-enter,
.slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}

.ag-grid-table {
	@media screen and (max-height: 800px) {
		height: 270px;
	}
}

.sick-days-breach {
	background-color: lightcoral !important;
}
</style>
